export var ItemRestriction;
(function(ItemRestriction) {
    ItemRestriction[/**
     * A Vista Loyalty membership is required (see [[Member]]).
     */ "Member"] = "Member";
})(ItemRestriction || (ItemRestriction = {}));

//# sourceMappingURL=item-restriction.js.map